








import { Component, Vue } from 'vue-property-decorator'

@Component({
  components: {
  }
})
export default class Entry extends Vue {

  private data: any = null

  private app_id: any = this.$route.query.app_id

  private async toGzhManager () {
    await this.$router.push({ path: '/gzh_menu_manager', query: { app_id: this.app_id } })
  }
}
